// export default function BranchContact() {
//     const branches = [
//         {
//             name: "AKHERIGANJ BRANCH",
//             email: "bmakheriganj@murshidabaddccb.bank.in",
//             person: "B.M.-In-Charge",
//             number: "9874923048",
//         },
//         {
//             name: "BELDANGA BRANCH",
//             email: "bmbeldanga@murshidabaddccb.bank.in",
//             person: "Branch Manager",
//             number: "7872478611",
//         },
//         {
//             name: "DOMKAL BRANCH",
//             email: "bmdomkal@murshidabaddccb.bank.in",
//             person: "Branch Manager",
//             number: "7872478647",
//         },
//         {
//             name: "FARAKKA BRANCH",
//             email: "bmfarakka@murshidabaddccb.bank.in",
//             person: "Branch Manager",
//             number: "7872478638",
//         },
//         {
//             name: "GRAMSALIKA BRANCH",
//             email: "bmgramsalika@murshidabaddccb.bank.in",
//             person: "Branch Manager",
//             number: "7872751111",
//         },
//         {
//             name: "ISLAMPUR BRANCH",
//             email: "bmislampur@murshidabaddccb.bank.in",
//             person: "Branch Manager",
//             number: "7872771111",
//         },
//         {
//             name: "JANGIPUR BRANCH",
//             email: "bmjangipur@murshidabaddccb.bank.in",
//             person: "Branch Manager",
//             number: "7872004422",
//         },
//         {
//             name: "KANDI BRANCH",
//             email: "bmkandi@murshidabaddccb.bank.in",
//             person: "Branch Manager",
//             number: "7872478624",
//         },
//     ];

//     return (
//         <div className="w-full bg-gray-50 py-16 px-4 flex justify-center">
//             <div className="max-w-6xl w-full bg-white shadow rounded-xl overflow-hidden border">

//                 {/* Table Header */}
//                 <div className="grid grid-cols-4 bg-gray-100 px-6 py-4 font-semibold text-gray-700 text-sm md:text-base">
//                     <div>NAME OF BRANCHES</div>
//                     <div>EMAIL</div>
//                     <div>CONTACT PERSON</div>
//                     <div>CONTACT NUMBER</div>
//                 </div>

//                 {/* Table Body */}
//                 <div>
//                     {branches.map((b, i) => (
//                         <div
//                             key={i}
//                             className="grid grid-cols-4 px-6 py-4 border-b text-gray-700 text-sm md:text-base hover:bg-gray-50 transition"
//                         >
//                             <div className="font-medium">{b.name}</div>
//                             <div>{b.email}</div>
//                             <div>{b.person}</div>
//                             <div>{b.number}</div>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         </div>
//     );
// }


export default function BranchContact() {
    const branches = [
        {
            name: "HEAD OFFICE BRANCH",
            email: "ho@murshidabaddccb.bank.in",
            person: "CEO",
            number: "7605071507",
        },
        {
            name: "KANDI BRANCH",
            email: "bmkandi@murshidabaddccb.bank.in",
            person: "MINTU KUMAR BAGDI",
            number: "7872751111",
        },
        {
            name: "LALBAGH BRANCH",
            email: "bmlalbagh@murshidabaddccb.bank.in",
            person: "SUDIPTO PAL",
            number: "7872478637",
        },
        {
            name: "JANGIPUR BRANCH",
            email: "bmjangipur@murshidabaddccb.bank.in",
            person: "TAMAL DEB",
            number: "7872478638",
        },
        {
            name: "BELDANGA BRANCH",
            email: "bmbeldanga@murshidabaddccb.bank.in",
            person: "ABHISHEK DUTTA",
            number: "7872478611",
        },
        {
            name: "DOMKAL BRANCH",
            email: "bmdomkal@murshidabaddccb.bank.in",
            person: "ANJAN ROY CHOWDHURY",
            number: "9733846102",
        },
        {
            name: "KHAGRA BRANCH",
            email: "bmkhagra@murshidabaddccb.bank.in",
            person: "SUJATA BANERJEE",
            number: "9564414383",
        },
        {
            name: "GRAMSALIKA BRANCH",
            email: "bmgramsalika@murshidabaddccb.bank.in",
            person: "SANDIPAN DAS",
            number: "7872761111",
        },
        {
            name: "SAGARDIGHI BRANCH",
            email: "bmsagardighi@murshidabaddccb.bank.in",
            person: "KRISHNA PRASAD",
            number: "7605082619",
        },
        {
            name: "FARAKKA BRANCH",
            email: "bmfarakka@murshidabaddccb.bank.in",
            person: "JIAUR RAHAMAN",
            number: "7872478650",
        },
        {
            name: "NAGAR BRANCH",
            email: "bmnagar@murshidabaddccb.bank.in",
            person: "SWAPAN KUMAR BISWAS",
            number: "8926337868",
        },
        {
            name: "LALGOLA BRANCH",
            email: "bmlalgola@murshidabaddccb.bank.in",
            person: "PRIYABARTA HALDER",
            number: "9874923048",
        },
        {
            name: "PANCHANANTALA BRANCH",
            email: "bmpanchanantala@murshidabaddccb.bank.in",
            person: "SUPRIYO MAHALI",
            number: "7872007722",
        },
        {
            name: "MAIN BRANCH",
            email: "bmmain@murshidabaddccb.bank.in",
            person: "SOUMEN SARKAR",
            number: "7872478620",
        },
        {
            name: "NABAGRAM BRANCH",
            email: "bmnabagram@murshidabaddccb.bank.in",
            person: "KUMAR KANTI DHAR",
            number: "8768441761",
        },
        {
            name: "ISLAMPUR BRANCH",
            email: "bmislampur@murshidabaddccb.bank.in",
            person: "SOUMYA CHAKRABORTY",
            number: "7872478630",
        },
        {
            name: "SALAR BRANCH",
            email: "bmsalar@murshidabaddccb.bank.in",
            person: "ABHIJIT BISWAS",
            number: "9231908012",
        },
        {
            name: "SAKTIPUR BRANCH",
            email: "bmsaktipur@murshidabaddccb.bank.in",
            person: "SUPRAVAT KAYAL",
            number: "7596034986",
        },
        {
            name: "RAIPUR BRANCH",
            email: "bmraipur@murshidabaddccb.bank.in",
            person: "DEBABRATA SARKAR",
            number: "7872478613",
        },
        {
            name: "KUMARSANDA BRANCH",
            email: "bmkumarsanda@murshidabaddccb.bank.in",
            person: "DEBABRATA SARKAR",
            number: "7872478613",
        }
    ];

    return (
        <div className="w-full bg-gray-50 py-10 px-4 flex justify-center">
            <div className="max-w-6xl w-full bg-white shadow rounded-xl overflow-hidden border">

                {/* Table Header — Desktop Only */}
                <div className="hidden md:grid grid-cols-12 gap-2 bg-gray-100 px-6 py-4 font-semibold text-gray-700 text-base">
                    <div className="col-span-3">NAME OF BRANCHES</div>
                    <div className="col-span-4">EMAIL</div>
                    <div className="col-span-3">CONTACT PERSON</div>
                    <div className="col-span-2">CONTACT NUMBER</div>
                </div>

                {/* Body */}
                <div>
                    {branches.map((b, i) => (
                        <div
                            key={i}
                            className="
                                border-b px-6 py-4 text-gray-700 
                                hover:bg-gray-50 transition
                                grid grid-cols-1 md:grid-cols-12 gap-2 items-center
                            "
                        >
                            {/* Name */}
                            <div className="md:col-span-3">
                                <p className="md:hidden text-gray-500 text-xs font-semibold">BRANCH NAME</p>
                                <p className="font-medium">{b.name}</p>
                            </div>

                            {/* Email */}
                            <div className="md:col-span-4">
                                <p className="md:hidden text-gray-500 text-xs font-semibold">EMAIL</p>
                                <p className="break-all md:break-normal md:whitespace-nowrap text-blue-600 hover:underline">
                                    <a href={`mailto:${b.email}`}>{b.email}</a>
                                </p>
                            </div>

                            {/* Person */}
                            <div className="md:col-span-3">
                                <p className="md:hidden text-gray-500 text-xs font-semibold">CONTACT PERSON</p>
                                <p>{b.person}</p>
                            </div>

                            {/* Number */}
                            <div className="md:col-span-2">
                                <p className="md:hidden text-gray-500 text-xs font-semibold">CONTACT NUMBER</p>
                                <p>{b.number}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
}
